import { createContext } from "react";
export const ProviderContext = createContext({
    push: () => { },
    count: () => 0,
    modals: null
});
export const ContainerContext = createContext({
    hide: () => { },
    setFooter: (status) => { },
    listeners: { current: {
            onHide: () => { }
        } },
    initPosition: { current: undefined },
    footer: undefined,
    footerRef: { current: undefined }
});
export const WithModalContext = createContext({
    withModal: false,
    setConfig: () => { },
    state: {},
    footerRef: null,
    showPopup: () => { },
    show: () => { },
    hide: () => { }
});
